// src/pages/GuestDashboard.jsx
import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import guestAvatar from '../assets/guest.jpg';
import { useNavigate } from 'react-router-dom';
import { FiPower } from 'react-icons/fi';

export default function GuestDashboard() {
  const { user, token, logout, setUser, setToken } = useAuth();
  const [editMode, setEditMode] = useState(false);
  const [profile, setProfile] = useState({
    name: user?.name || '',
    email: user?.email || ''
  });
  const [reservations, setReservations] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Sincronizeaza profile cu user cand se schimba user-ul
  useEffect(() => {
    if (user) {
      setProfile({
        name: user.name || '',
        email: user.email || ''
      });
    }
  }, [user]);

  // Incarca user si token din localStorage la mount

  useEffect(() => {
    if (!user) return;

    const fetchData = async () => {
      try {
        const resReservations = await axios.get('/api/guest/reservations', {
          headers: { Authorization: `Bearer ${token}` }
        });
        setReservations(resReservations.data.reservations || []);

        const resFavorites = await axios.get('/api/guest/favorites', {
          headers: { Authorization: `Bearer ${token}` }
        });
        setFavorites(resFavorites.data.favorites || []);
      } catch (err) {
        console.error(err);
        setReservations([]);
        setFavorites([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [user, token]);

  const handleSaveProfile = async () => {
    try {
      const res = await axios.put('/api/guest/profile', profile);

      if (res.data.token) {
        localStorage.setItem('token', res.data.token);
        setToken(res.data.token);
      }

      localStorage.setItem('user', JSON.stringify(res.data.user));
      setUser(res.data.user);

      setEditMode(false);
      alert('Profil actualizat cu succes!');
    } catch (err) {
      console.error(err);
      alert('Eroare la salvarea profilului');
    }
  };

  if (loading) return (
    <div style={{
      padding: '2rem',
      textAlign: 'center',
      fontFamily: "'Sora', sans-serif",
      color: '#006d77'
    }}>
      Se incarca...
    </div>
  );

  const handleLogout = () => {
    logout();      // curata token si user
    navigate('/'); // redirectioneaza la home
  };


  return (
    <div style={{
      padding: '1rem',
      fontFamily: "'Sora', sans-serif",
      maxWidth: '600px',
      margin: '0 auto',
      color: '#333'
    }}>
      {/* Profil si Avatar */}
      <div style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: '1rem',
        marginBottom: '1.5rem',
        flexWrap: 'wrap'
      }}>
        {/* Coloana Avatar + Navigare */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '0.5rem'
          }}
        >
          {/* Buton Home */}
          <button
            onClick={() => navigate('/')}
            style={{
              padding: '0',
              backgroundColor: 'transparent',
              color: '#dd4124',
              border: 'none',
              borderRadius: '0',
              width: '32px',
              height: '32px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.5rem',
              fontWeight: 'bold'
            }}
            title="Inapoi la ecranul principal"
          >
            ⇐
          </button>

          {/* Avatar */}
          <img
            src={guestAvatar}
            alt="Avatar"
            style={{
              width: '70px',
              height: '70px',
              borderRadius: '50%',
              border: '2px solid #006d77',
              objectFit: 'cover'
            }}
          />

          {/* Logout */}
          <button
            onClick={handleLogout}
            style={{
              width: '40px',
              height: '40px',
              minWidth: '40px',
              minHeight: '40px',
              backgroundColor: 'transparent',
              color: '#dd4124',
              border: 'none',
              borderRadius: '50%',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 0,
              flexShrink: 0,
            }}
            title="Logout"
          >
            <FiPower size={20} />
          </button>
        </div>

        {/* Coloana Date Profil */}
        <div style={{ flex: 1 }}>
          {editMode ? (
            <>
              <input
                type="text"
                value={profile.name}
                onChange={(e) => setProfile({ ...profile, name: e.target.value })}
                placeholder="Nume si prenume"
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  fontSize: '0.9rem',
                  marginBottom: '0.5rem',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  fontFamily: "'Sora', sans-serif"
                }}
              />
              <input
                type="email"
                value={profile.email}
                onChange={(e) => setProfile({ ...profile, email: e.target.value })}
                placeholder="Email"
                style={{
                  width: '100%',
                  padding: '0.5rem',
                  fontSize: '0.9rem',
                  marginBottom: '0.5rem',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  fontFamily: "'Sora', sans-serif"
                }}
              />
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <button
                  onClick={handleSaveProfile}
                  style={{
                    padding: '0.4rem 0.8rem',
                    fontSize: '0.85rem',
                    backgroundColor: '#006d77',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontFamily: "'Sora', sans-serif"
                  }}
                >
                  Salveaza
                </button>
                <button
                  onClick={() => setEditMode(false)}
                  style={{
                    padding: '0.4rem 0.8rem',
                    fontSize: '0.85rem',
                    backgroundColor: '#dd4124',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontFamily: "'Sora', sans-serif"
                  }}
                >
                  Renunta
                </button>
              </div>
            </>
          ) : (
            <>
              <h3 style={{
                margin: '0 0 0.3rem 0',
                color: '#006d77',
                fontSize: '1.1rem'
              }}>
                {user?.name || 'Utilizator'}
              </h3>
              <p style={{
                margin: '0 0 0.5rem 0',
                color: '#666',
                fontSize: '0.85rem'
              }}>
                {user?.email || 'Email necunoscut'}
              </p>
              <button
                onClick={() => setEditMode(true)}
                style={{
                  padding: '0.3rem 0.6rem',
                  fontSize: '0.8rem',
                  border: '1px solid #006d77',
                  borderRadius: '4px',
                  background: 'transparent',
                  color: '#006d77',
                  cursor: 'pointer',
                  fontFamily: "'Sora', sans-serif"
                }}
              >
                Editeaza profil
              </button>
            </>
          )}
        </div>
      </div>

      {/* Rezervari */}
      <section style={{
        marginBottom: '1.2rem',
        padding: '1rem',
        border: '1px solid #eaeaea',
        borderRadius: '6px'
      }}>
        <h4 style={{
          color: '#006d77',
          margin: '0 0 0.8rem 0',
          fontSize: '1rem',
          fontWeight: '600'
        }}>
          Rezervari
        </h4>
        {reservations.length === 0 ? (
          <p style={{
            color: '#666',
            fontSize: '0.85rem',
            margin: 0
          }}>
            Nu ai rezervari.
          </p>
        ) : (
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.6rem'
          }}>
            {reservations.map(r => (
              <div
                key={r._id}
                style={{
                  border: '1px solid #eaeaea',
                  borderRadius: '4px',
                  padding: '0.6rem',
                  fontSize: '0.85rem'
                }}
              >
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                  flexWrap: 'wrap',
                  gap: '0.3rem',
                  marginBottom: '0.3rem'
                }}>
                  <strong style={{ color: '#006d77' }}>{r.propertyTitle}</strong>
                  <span style={{
                    backgroundColor: r.status === 'confirmed' ? '#e6f7f0' : '#fff3e6',
                    color: r.status === 'confirmed' ? '#006d77' : '#dd4124',
                    padding: '0.2rem 0.4rem',
                    borderRadius: '8px',
                    fontSize: '0.75rem'
                  }}>
                    {r.status}
                  </span>
                </div>
                <div style={{
                  color: '#666',
                  fontSize: '0.8rem'
                }}>
                  📅 {r.startDate} - {r.endDate}
                </div>
              </div>
            ))}
          </div>
        )}
      </section>

      {/* Favorite */}
      <section style={{
        marginBottom: '1.2rem',
        padding: '1rem',
        border: '1px solid #eaeaea',
        borderRadius: '6px'
      }}>
        <h4 style={{
          color: '#006d77',
          margin: '0 0 0.8rem 0',
          fontSize: '1rem',
          fontWeight: '600'
        }}>
          Favorite
        </h4>
        {favorites.length === 0 ? (
          <p style={{
            color: '#666',
            fontSize: '0.85rem',
            margin: 0
          }}>
            Nu ai favorite.
          </p>
        ) : (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
            gap: '0.6rem'
          }}>
            {favorites.map(f => (
              <div
                key={f._id}
                style={{
                  border: '1px solid #eaeaea',
                  padding: '0.6rem',
                  borderRadius: '4px',
                  fontSize: '0.85rem'
                }}
              >
                <strong style={{ color: '#006d77' }}>{f.title}</strong>
              </div>
            ))}
          </div>
        )}
      </section>

      {/* Recenzii */}
      <section style={{
        padding: '1rem',
        border: '1px solid #eaeaea',
        borderRadius: '6px'
      }}>
        <h4 style={{
          color: '#006d77',
          margin: '0 0 0.8rem 0',
          fontSize: '1rem',
          fontWeight: '600'
        }}>
          Recenzii
        </h4>
        {reservations.length === 0 ? (
          <p style={{
            color: '#666',
            fontSize: '0.85rem',
            margin: 0
          }}>
            Momentan nu ai recenzii de trimis.
          </p>
        ) : (
          reservations.map(r => (
            <div
              key={r._id}
              style={{
                marginBottom: '0.8rem',
                paddingBottom: '0.8rem',
                borderBottom: '1px solid #eaeaea'
              }}
            >
              <div style={{
                color: '#006d77',
                fontSize: '0.9rem',
                marginBottom: '0.4rem'
              }}>
                {r.propertyTitle}
              </div>
              <textarea
                placeholder="Scrie o recenzie..."
                style={{
                  width: '100%',
                  minHeight: '60px',
                  padding: '0.5rem',
                  fontSize: '0.85rem',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                  resize: 'vertical',
                  fontFamily: "'Sora', sans-serif"
                }}
              />
              <button style={{
                padding: '0.3rem 0.6rem',
                fontSize: '0.8rem',
                backgroundColor: '#006d77',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                marginTop: '0.4rem',
                fontFamily: "'Sora', sans-serif"
              }}>
                Trimite recenzie
              </button>
            </div>
          ))
        )}
      </section>
    </div>
  );
}